/* eslint-disable react-hooks/rules-of-hooks,react/display-name */
import { useRef } from 'react';
import { useZusModalStore, ModalWrapper } from '@/helpers/modal.js';

const YouTubeModal = (Component) => function ({ videoId, isPopin, ...props }) {
  const { setModal1, setModal2 } = useZusModalStore.getState();
  const divRef = useRef();
  const embedUrl = `https://www.youtube.com/embed/${videoId}`;
  async function onClick() {
    const content = (
      <ModalWrapper onClose={() => (isPopin ? setModal2(null) : setModal1(null))} delay={50}>
        <div className="w-screen h-dvh lg:h-screen overflow-hidden bg-white p-6 lg:p-20" ref={divRef}>
          <div className="rounded-2xl overflow-hidden h-full w-full">
            <iframe style={{ width: '100%', height: '100%' }} src={`${embedUrl}?autoplay=1`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen />
          </div>
        </div>
      </ModalWrapper>
    );
    return setModal1(content);
  }

  return (
    <Component openModalYoutube={() => onClick()} {...props} />
  );
};

// Vidéo Instagram (post/reel) ouverte dans une modale blanche, sans quitter la page.
export const InstagramModal = (Component) => function ({ postUrl, ...props }) {
  const { setModal1 } = useZusModalStore.getState();
  const embedUrl = `${postUrl.replace(/\/?$/, '/')}embed/`;
  function onClick() {
    setModal1(
      <ModalWrapper onClose={() => setModal1(null)} delay={50}>
        <div className="flex h-dvh w-screen items-center justify-center overflow-hidden bg-white p-4 lg:h-screen lg:p-12">
          <div className="h-full w-full max-w-[520px] overflow-hidden rounded-2xl border border-was-ink/8 bg-white">
            <iframe style={{ width: '100%', height: '100%' }} src={embedUrl} title="Instagram" frameBorder="0" scrolling="no" allow="encrypted-media; picture-in-picture; web-share" allowFullScreen />
          </div>
        </div>
      </ModalWrapper>,
    );
  }
  return <Component openModalInstagram={() => onClick()} {...props} />;
};

export default YouTubeModal;
